module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_dropdown_black-d777ff6702581da1381c6d1ce6469aca.svg";